"use client";
import { UseFormReturn } from "react-hook-form";
import { RESERVE_TEXTS } from "@/features/reserve/utils/utils-reserve";
import { HookFormTextInput } from "@cmp-src/form/TextInput";
import { Label } from "@cmp-src/primitives/label";
import { ReserveFieldDescription } from "@/features/reserve/components/ReserveFieldDescription/ReserveFieldDescription";
import React from "react";
import { DescriptionIcon } from "@gettactic/components/src/icons/TacticIcons/DescriptionIcon";
import { Button } from "@cmp-src/primitives/button";

type ReserveTitleProps = {
  form: UseFormReturn<any>;
  withDescription?: boolean;
  showLabel?: boolean;
};

export function ReserveFieldTitle({
  form,
  withDescription,
  showLabel = true
}: ReserveTitleProps) {
  const [notesOpened, setNotesOpened] = React.useState(false);
  return (
    <div className="flex flex-col gap-1.5">
      {showLabel && <Label htmlFor="title">Title</Label>}
      <div className="flex items-center gap-2">
        <HookFormTextInput
          form={form}
          name="title"
          id="title"
          placeholder={RESERVE_TEXTS.addTitle}
          className="min-w-0"
        />
        {withDescription && (
          <Button
            type="button"
            variant="outline"
            size="trigger"
            className="aspect-square shrink-0 rounded-md px-0 shadow-input"
            aria-label="Add a description"
            aria-pressed={notesOpened}
            onClick={(e) => {
              e.preventDefault();
              setNotesOpened((s) => !s);
            }}
          >
            <DescriptionIcon />
          </Button>
        )}
      </div>
      {withDescription && notesOpened && (
        <ReserveFieldDescription form={form} />
      )}
    </div>
  );
}
